// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import {WOW} from 'wowjs'
import animated from 'wowjs/css/libs/animate.css'
Vue.use(animated)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import store from '../store'

import axios from 'axios'  // 安装axios后引入
Vue.prototype.$axios = axios  // 将axios挂载到原型上方便使用

import App from './App'
import router from './router'
router.afterEach(() => {
  window.scrollTo(0,1)
  window.scrollTo(0,0)
})


Vue.prototype.$wow = new WOW({
    boxClass: 'wow', // 需要执行动画的元素的 class
    animateClass: 'animated', //animation.css 动画的 class
    offset: 0, // 距离可视区域多少开始执行动画
    mobile: true, // 是否在移动设备上执行动画
    live: false, // 异步加载的内容是否有效
})
Vue.config.productionTip = false

Vue.prototype.loadJs = function(src) {
  return new Promise((resolve,reject)=>{
    let script = document.createElement('script');
    script.type = "text/javascript";
    script.src= src;
    document.body.appendChild(script);

    script.onload = ()=>{
      resolve();
    }
    script.onerror = ()=>{
      reject();
    }
  })
}
Vue.prototype.loadJson = function(src) {
  return new Promise((resolve,reject)=>{
    this.$axios.get(src).then(res => {
        resolve(res.data);
    }).catch(err=>{
        reject(err.code);
    })
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js